<template>
  <b-modal
    ref="modal-modeloenviowhatsapp"
    scrollable
    centered
    :hide-footer="true"
    @hide="hideModal"
    @close="hideModal"
  >
    <template #modal-title>
      Selecione o modelo para o envio
    </template>

    <div>
      <label class="form-label">Deseja enviar agora ou programar?</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="send-now"
          value="now"
          v-model="sendOption"
        />
        <label class="form-check-label" for="send-now">
          Enviar agora
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="schedule"
          value="schedule"
          v-model="sendOption"
        />
        <label class="form-check-label" for="schedule">
          Programar
        </label>
      </div>
      <div v-if="currentRecurrence">
          <label class="form-label">Status</label>
          <ToogleSwitch v-model="status"/>
        </div>
    </div>

    <ModalPeriodicidade
      v-if="sendOption === 'schedule'"
      ref="ModalPeriodicidade"
      :trigger-generate="generateCronTrigger"
      :cron-expression="currentRecurrence ? currentRecurrence.cronPeriodicidade : null"
      @cron-generated="handleCronGenerated"
    />
    <BaseSelectModeloEnvio
      ref="BaseSelectModeloEnvio"
      :selected-modelo="data.modeloEnvioId"
      @select="setValueOnData"
    />

    <DefaultButton
      btnVariant="btn-third justify-content-center"
      :onClick="onCreateAcao"
      icon="fas fa-check-circle"
      text="Salvar"
    />
  </b-modal>
</template>

<script>
import { toast, loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'
import RecorrenciaListaInteligenteRepository from '@/shared/http/repositories/configurations/recorrenciaListaInteligente.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import BaseSelectModeloEnvio from '@/views/private/configurations/lista-inteligente/components/add/component/BaseSelectModeloEnvio.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import ModalPeriodicidade from '../component/ModalPeriodicidade.vue'

const AcaoListaInteligenteData = {
  modeloEnvioId: null,
  acaoListaInteligente: 'SEND_WHATSAPP',
  cronExpression: ''
}

export default {
  name: 'SendWhatsappListaInteligenteModal',
  components: {
    DefaultButton,
    BaseSelectModeloEnvio,
    ModalPeriodicidade,
    ToogleSwitch
  },
  data () {
    return {
      data: AcaoListaInteligenteData,
      acaoListaId: null,
      generateCronTrigger: false,
      sendOption: 'now',
      status: false
    }
  },
  methods: {
    showModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.getRecorrencia()
        this.$refs['modal-modeloenviowhatsapp'].show()
      }
    },
    hideModal () {
      this.$refs['modal-modeloenviowhatsapp'].hide()
    },
    setValueOnData (modeloId) {
      this.data.modeloEnvioId = modeloId
    },
    handleCronGenerated (cronExpression) {
      this.data.cronExpression = cronExpression
      const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'SEND_WHATSAPP')

      if (foundRecurrence) {
        this.updateRecorrencia()
        this.$emit('reloadAcoes')
      } else {
        this.createRecorrencia()
        this.$emit('reloadAcoes')
      }
    },
    onCreateAcao () {
      if (this.sendOption === 'schedule') {
        this.generateCronTrigger = true
        this.$nextTick(() => {
          this.generateCronTrigger = false
        })
      } else {
        this.finalizeCreateAcao()
      }
    },
    finalizeCreateAcao () {
      if (this.data.modeloEnvioId && (this.sendOption === 'now' || this.data.cronExpression)) {
        loading.push()
        ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
          .then((response) => {
            if (response.status === 201) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.hideModal()
              this.$emit('reloadAcoes')
            }
            loading.close()
          })
          .catch(this.onException)
      }
    },
    createRecorrencia () {
      const payload = {
        listaInteligenteId: this.acaoListaId,
        modeloEnvioId: this.data.modeloEnvioId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente
      }

      RecorrenciaListaInteligenteRepository.Create(payload)
        .then((response) => {
          if (response.status === 201) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
        })
        .catch((error) => {
          console.error('Erro ao criar recorrência:', error)
        })
    },
    getRecorrencia () {
      RecorrenciaListaInteligenteRepository.GetById(this.acaoListaId)
        .then((response) => {
          if (response.status === 200 && Array.isArray(response.data.content)) {
            this.recorrencia = response.data.content

            const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'SEND_WHATSAPP')

            if (foundRecurrence) {
              this.currentRecurrence = foundRecurrence
              this.sendOption = 'schedule'
              this.data.cronExpression = foundRecurrence.cronPeriodicidade
              this.editCronExpression = this.data.cronExpression
              this.data.modeloEnvioId = foundRecurrence.modeloEnvio.id
              this.status = foundRecurrence.status
            } else {
              this.currentRecurrence = null
              this.sendOption = 'now'
              this.data.cronExpression = null
              this.data.modeloEnvioId = null
            }
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar recorrência:', error)
        })
    },
    updateRecorrencia () {
      if (!this.currentRecurrence) {
        return
      }

      const payload = {
        id: this.currentRecurrence.id,
        listaInteligenteId: this.acaoListaId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente,
        modeloEnvioId: this.data.modeloEnvioId,
        status: this.status
      }
      RecorrenciaListaInteligenteRepository.Update(payload)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
        })
        .catch((error) => {
          console.error('Erro ao atualizar recorrência:', error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/SendWhatsappListaInteligenteModal.vue